import apiClient from '@/lib/apiClient';
import { ApiResponse } from '@/types/api';

export interface IntegrationModule {
  slug: string;
  name: string;
  category: 'marketplace' | 'payment' | 'shipping' | string;
  description: string;
  color: string;
  icon: string;
  docs_url: string;
  is_connected: boolean;
}

export interface IntegrationCategory {
  category: string;
  label: string;
  integrations: IntegrationModule[];
}

export const integrationApi = {
  /**
   * List all integration modules grouped by category,
   * annotated with whether the current tenant has it connected.
   */
  listAll: async (category?: string): Promise<IntegrationCategory[]> => {
    const response = await apiClient.get<ApiResponse<IntegrationCategory[]>>(
      '/integrations',
      { params: category ? { category } : undefined }
    );
    return response.data.data!;
  },

  /**
   * Connect an integration for the current tenant.
   */
  connect: async (
    slug: string,
    config?: Record<string, unknown>
  ): Promise<void> => {
    await apiClient.post(`/integrations/${slug}/connect`, {
      config: config ?? {},
    });
  },

  /**
   * Disconnect an integration for the current tenant.
   */
  disconnect: async (slug: string): Promise<void> => {
    await apiClient.delete(`/integrations/${slug}`);
  },
};
